import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LinePlanEntityCard from './LinePlanEntityCard';
import ProductCard from './ProductCard';
function DraggableCard({ card, entityType, onClick, scale = 'medium' }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: card.id
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1
    };
    return (_jsx("div", { ref: setNodeRef, style: style, ...attributes, ...listeners, children: entityType === 'project' || entityType === 'expression' ? (_jsx(LinePlanEntityCard, { card: card, entityType: entityType, onClick: onClick, scale: scale })) : (_jsx(ProductCard, { card: card, onClick: onClick, scale: scale })) }));
}
export default DraggableCard;
